import { writable, readable, get } from 'svelte/store';
import { env } from '$env/dynamic/public';
import { t, locale } from '$lib/locales';

const trad = get(t);

export let headerTitle = writable('');
export let headerSubtitle = writable('');
export let showHeader = writable(true);

export const isMobileApp = writable(null);

// innerWidth and innerHeight used to set landscape/portrait phone store flags (in px)
export const MIN_LANDSCAPE_HEIGHT = 500;
export const MIN_LANDSCAPE_WIDTH = 500;
export const MAX_PORTRAIT_WIDTH = 500;
export let isPortraitPhone = writable(false);
export let isLandscapePhone = writable(false);

export let DEBUG = writable(true); // Set to true to print logs in console
export let bearer = writable(null);
export const showHelp = writable(true);

export const TEST_ENABLED = `,${env.ENABLED_FEATURES?.toLowerCase()},`.includes(',test,');

export const windowHeight = writable(null);
export const windowWidth = writable(null);

export const showAlert = writable(false);

/* Format dates & time */
export const formatDate = (date) => {
	if (!date) return null;
	const dateObject = new Date(date);
	return (
		dateObject.toLocaleDateString(get(locale)) +
		' ' +
		dateObject.toLocaleTimeString(get(locale), { hour: '2-digit', minute: '2-digit' })
	);
};
export const formatDateWithoutTime = (date) => {
	if (!date) return null;
	const dateObject = new Date(date);
	return dateObject.toLocaleDateString(get(locale));
};
export const formatTime = (date) => {
	if (!date) return null;
	const dateObject = new Date(date);
	return dateObject.toLocaleTimeString(get(locale), { hour: '2-digit', minute: '2-digit' });
};

export const locale_dates = readable(() => {
	return {
		weekdays: [
			trad('dates.small_sunday'),
			trad('dates.small_monday'),
			trad('dates.small_tuesday'),
			trad('dates.small_wednesday'),
			trad('dates.small_thursday'),
			trad('dates.small_friday'),
			trad('dates.small_saturday')
		],
		months: [
			trad('dates.january'),
			trad('dates.february'),
			trad('dates.march'),
			trad('dates.april'),
			trad('dates.may'),
			trad('dates.june'),
			trad('dates.july'),
			trad('dates.august'),
			trad('dates.september'),
			trad('dates.october'),
			trad('dates.november'),
			trad('dates.december')
		]
	};
});
